/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Autotrackbody2Inputs */

const id_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami secara otomatis melacak dan memperbarui data game dari sumber yang tersedia untuk umum, termasuk Epic Games Store. Kami memuat aset grafis langsung dari server mereka dan tidak menyimpannya.`)
};

const ms_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami secara automatik menjejak dan mengemas kini data permainan daripada sumber yang tersedia secara umum, termasuk Epic Games Store. Kami memuatkan aset grafik terus dari pelayan mereka dan tidak menyimpannya.`)
};

const da_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi sporer og opdaterer automatisk spildata fra offentligt tilgængelige kilder, inklusive Epic Games Store. Vi indlæser grafiske aktiver direkte fra deres servere og gemmer dem ikke.`)
};

const de_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verfolgen und aktualisieren automatisch Spieldaten aus öffentlich zugänglichen Quellen, einschließlich des Epic Games Store. Wir laden grafische Assets direkt von deren Servern und speichern sie nicht.`)
};

const en_us2_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We automatically track and update game data from publicly available sources, including the Epic Games Store. We load graphical assets directly from their servers and do not store them.`)
};

const es_es2_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamos y actualizamos automáticamente los datos de los juegos de fuentes públicamente disponibles, incluida la Epic Games Store. Cargamos los recursos gráficos directamente desde sus servidores y no los almacenamos.`)
};

const es_mx2_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamos y actualizamos automáticamente los datos de los juegos de fuentes públicamente disponibles, incluida la Epic Games Store. Cargamos los recursos gráficos directamente desde sus servidores y no los almacenamos.`)
};

const fil_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awtomatiko naming sinusubaybayan at ina-update ang data ng laro mula sa mga pampublikong available na source, kasama ang Epic Games Store. Naglo-load kami ng graphical assets direktang mula sa kanilang mga server at hindi namin iniimbak ang mga ito.`)
};

const fr_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous suivons et mettons automatiquement à jour les données des jeux à partir de sources publiquement disponibles, y compris l'Epic Games Store. Nous chargeons les ressources graphiques directement depuis leurs serveurs et ne les stockons pas.`)
};

const it_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamo e aggiorniamo automaticamente i dati dei giochi da fonti pubblicamente disponibili, inclusa l'Epic Games Store. Carichiamo le risorse grafiche direttamente dai loro server e non le memorizziamo.`)
};

const hu_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatikusan követjük és frissítjük a játékadatok nyilvánosan elérhető forrásokból, beleértve az Epic Games Store-t is. A grafikus asset-eket közvetlenül a szervereikről töltjük be, és nem tároljuk azokat.`)
};

const nl_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We volgen en updaten automatisch gamegegevens uit openbaar beschikbare bronnen, waaronder de Epic Games Store. We laden grafische assets rechtstreeks van hun servers en slaan ze niet op.`)
};

const no_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi sporer og oppdaterer automatisk spilldata fra offentlig tilgjengelige kilder, inkludert Epic Games Store. Vi laster grafiske eiendeler direkte fra deres servere og lagrer dem ikke.`)
};

const pl_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatycznie śledzimy i aktualizujemy dane gier z publicznie dostępnych źródeł, w tym Epic Games Store. Ładujemy zasoby graficzne bezpośrednio z ich serwerów i nie przechowujemy ich.`)
};

const pt_br2_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamos e atualizamos automaticamente dados de jogos de fontes públicas, incluindo a Epic Games Store. Carregamos os assets gráficos diretamente dos servidores deles e não os armazenamos.`)
};

const pt_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registamos e atualizamos automaticamente os dados dos jogos a partir de fontes publicamente disponíveis, incluindo a Epic Games Store. Carregamos os recursos gráficos diretamente dos seus servidores e não os armazenamos.`)
};

const ro_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmărim și actualizăm automat datele jocurilor din surse disponibile public, inclusiv Epic Games Store. Încărcăm activele grafice direct de pe serverele lor și nu le stocăm.`)
};

const fi_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraamme ja päivitämme automaattisesti pelitietoja julkisista lähteistä, mukaan lukien Epic Games Store. Lataamme graafiset resurssit suoraan heidän palvelimiltaan emmekä tallenna niitä.`)
};

const sv_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi spårar och uppdaterar automatiskt speldata från offentligt tillgängliga källor, inklusive Epic Games Store. Vi laddar grafiska tillgångar direkt från deras servrar och lagrar dem inte.`)
};

const vi_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi tự động theo dõi và cập nhật dữ liệu game từ các nguồn công khai, bao gồm Epic Games Store. Chúng tôi tải tài nguyên đồ họa trực tiếp từ máy chủ của họ và không lưu trữ chúng.`)
};

const tr_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store dahil olmak üzere herkese açık kaynaklardan oyun verilerini otomatik olarak izler ve güncelleriz. Grafik varlıkları doğrudan sunucularından yükleriz ve bunları depolamayız.`)
};

const cs_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automaticky sledujeme a aktualizujeme herní data z veřejně dostupných zdrojů, včetně Epic Games Store. Grafické assety načítáme přímo z jejich serverů a neukládáme je.`)
};

const bg_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ние автоматично проследяваме и актуализираме игрови данни от публично достъпни източници, включително Epic Games Store. Зареждаме графични активи директно от техните сървъри и не ги съхраняваме.`)
};

const ru_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы автоматически отслеживаем и обновляем данные об играх из общедоступных источников, включая Epic Games Store. Мы загружаем графические ресурсы непосредственно с их серверов и не храним их.`)
};

const uk_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми автоматично відстежуємо та оновлюємо дані з загальнодоступних джерел, включаючи Epic Games Store. Ми завантажуємо графічні ресурси безпосередньо з їхніх серверів і не зберігаємо їх.`)
};

const ar_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتتبع ونحدث بيانات الألعاب تلقائيًا من المصادر المتاحة للجمهور، بما في ذلك Epic Games Store. نقوم بتحميل الأصول الرسومية مباشرة من خوادمهم ولا نخزنها.`)
};

const hi_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम सार्वजनिक रूप से उपलब्ध स्रोतों से गेम डेटा को स्वचालित रूप से ट्रैक और अपडेट करते हैं, जिसमें Epic Games Store भी शामिल है।`)
};

const th_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราติดตามและอัปเดตข้อมูลเกมโดยอัตโนมัติจากแหล่งข้อมูลสาธารณะ รวมถึง Epic Games Store เราจะโหลดทรัพยากรกราฟิกโดยตรงจากเซิร์ฟเวอร์ของพวกเขาและไม่จัดเก็บไว้`)
};

const ja_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store を含む公開情報源からゲームデータを自動的に追跡・更新しています。グラフィカルアセットは直接サーバーから読み込み、保存はしていません。`)
};

const zh_cn2_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们自动追踪并更新来自包括Epic游戏商城在内的公开可用来源的游戏数据。我们直接从其服务器加载图形资源，而不进行本地存储。`)
};

const zh_hant1_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們自動追蹤並更新來自包括Epic遊戲商城在內的公開可用來源的遊戲資料。我們直接從其伺服器載入圖形資源，而不進行本機儲存。`)
};

const ko_about_autotrackbody2 = /** @type {(inputs: About_Autotrackbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store를 포함한 공개적으로 이용 가능한 출처에서 게임 데이터를 자동으로 추적하고 업데이트합니다. 그래픽 에셋은 해당 서버에서 직접 로드하며 저장하지 않습니다.`)
};

/**
* | output |
* | --- |
* | "We automatically track and update game data from publicly available sources, including the Epic Games Store. We load graphical assets directly from their ser..." |
*
* @param {About_Autotrackbody2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_autotrackbody2 = /** @type {((inputs?: About_Autotrackbody2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Autotrackbody2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_autotrackbody2(inputs)
	if (locale === "ms") return ms_about_autotrackbody2(inputs)
	if (locale === "da") return da_about_autotrackbody2(inputs)
	if (locale === "de") return de_about_autotrackbody2(inputs)
	if (locale === "en-US") return en_us2_about_autotrackbody2(inputs)
	if (locale === "es-ES") return es_es2_about_autotrackbody2(inputs)
	if (locale === "es-MX") return es_mx2_about_autotrackbody2(inputs)
	if (locale === "fil") return fil_about_autotrackbody2(inputs)
	if (locale === "fr") return fr_about_autotrackbody2(inputs)
	if (locale === "it") return it_about_autotrackbody2(inputs)
	if (locale === "hu") return hu_about_autotrackbody2(inputs)
	if (locale === "nl") return nl_about_autotrackbody2(inputs)
	if (locale === "no") return no_about_autotrackbody2(inputs)
	if (locale === "pl") return pl_about_autotrackbody2(inputs)
	if (locale === "pt-BR") return pt_br2_about_autotrackbody2(inputs)
	if (locale === "pt") return pt_about_autotrackbody2(inputs)
	if (locale === "ro") return ro_about_autotrackbody2(inputs)
	if (locale === "fi") return fi_about_autotrackbody2(inputs)
	if (locale === "sv") return sv_about_autotrackbody2(inputs)
	if (locale === "vi") return vi_about_autotrackbody2(inputs)
	if (locale === "tr") return tr_about_autotrackbody2(inputs)
	if (locale === "cs") return cs_about_autotrackbody2(inputs)
	if (locale === "bg") return bg_about_autotrackbody2(inputs)
	if (locale === "ru") return ru_about_autotrackbody2(inputs)
	if (locale === "uk") return uk_about_autotrackbody2(inputs)
	if (locale === "ar") return ar_about_autotrackbody2(inputs)
	if (locale === "hi") return hi_about_autotrackbody2(inputs)
	if (locale === "th") return th_about_autotrackbody2(inputs)
	if (locale === "ja") return ja_about_autotrackbody2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_autotrackbody2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_autotrackbody2(inputs)
	return ko_about_autotrackbody2(inputs)
});
export { about_autotrackbody2 as "about.autoTrackBody" }